import { z } from 'zod';

import { orderIdSchema, orderLogsResultSchema, wireLogMsgTypeSchema } from '../orderLogs.mts';
import { AvaAIToolExecution } from '../toolExecution.mts';

export const getOrderWireLogsInputSchema = z.strictObject({
  orderId: orderIdSchema,
  msgType: wireLogMsgTypeSchema,
});

export const getOrderWireLogsToolContract = {
  execution: AvaAIToolExecution.Server,
  name: 'getOrderWireLogs',
  inputSchema: getOrderWireLogsInputSchema,
  outputSchema: orderLogsResultSchema,
} as const;
